import { Col, Row } from "antd";
import { t } from "i18next";
import React from "react";

import { IDozvolaInformacijeEditProps } from "../../../../../../modules/ministry/ministry.types";
import { DozvolaTipObjekta } from "../../../../../../modules/obligee/exciseLicences/exciseLicences.types";
import { AkciznaMarkicaKategorijaProzivoda } from "../../../../../../modules/obligee/exciseStamps/exciseStamps.types";
import { formatDateDDMMYY } from "../../../../../../utils/dateFormatter";
import style from "./LicenceDetailsTop.module.scss";

interface ILicenceDetailsTop {
  dataLicence: IDozvolaInformacijeEditProps;
  dataLicenceProduct: string;
  tipDozvoleId: DozvolaTipObjekta | null;
}

export const LicenceDetailsTop: React.FC<ILicenceDetailsTop> = ({
  dataLicence,
  dataLicenceProduct,
  tipDozvoleId,
}) => {
  const getTipObjekta = (tipObjekta: DozvolaTipObjekta | null) => {
    if (!tipObjekta) return "";

    switch (tipObjekta) {
      case DozvolaTipObjekta.SKLADISTE:
        return t("SETTINGS_OBJECTS.AKCIZNO_SKLADISTE");
      case DozvolaTipObjekta.PROIZVODNJA_SA_SKLADISTEM:
        return t("AKCIZNE_DOZVOLE.AKCIZNO_SKLADISTE_PROIZVODNI_POGON");
      default:
        return "";
    }
  };

  return (
    <Col span={24} className={style.mainContainer}>
      <Row className={style.row}>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {t("AKCIZNE_DOZVOLE.TIP_OBJEKTA")}:
          </span>
        </Col>

        <Col span={5}>
          <span className={style.fontSize}>{getTipObjekta(tipDozvoleId)}</span>
        </Col>
        <Col span={5}></Col>
        <Col span={5}></Col>
      </Row>
      <Row className={style.row}>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {t(
              "AKCIZNE_DOZVOLE.VRSTA_AKCIZNOG_PROIZVODA_KOJI_CE_SE_PROIZVODITI_I_SMESTATI_U_SKLADISTE"
            )}
            :
          </span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>{dataLicenceProduct}</span>
        </Col>
        {dataLicence?.kategorijaProizvodaId ===
        AkciznaMarkicaKategorijaProzivoda.DUVAN ? (
          <>
            <Col span={5} className="alignRight">
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.KOLICINA_DUVANA_U_KG")}:
              </span>
            </Col>
            <Col span={5}>
              <span className={style.fontSize}>
                {dataLicence.kolicinaDuvanaKg ?? "/"}
              </span>
            </Col>
            <Col span={5}></Col>
            <Col span={5}></Col>
            <Col span={5} className="alignRight" style={{ paddingBottom: 15 }}>
              <span className={style.fontSize}>
                {t(
                  "AKCIZNE_DOZVOLE.KOLICINA_POJEDINACNIH_PAKOVANJA_U_KOMADIMA"
                )}
                :
              </span>
            </Col>
            <Col span={5}>
              <span className={style.fontSize}>
                {dataLicence.kolicinaPojedinacnihPakovanjaKomadi ?? "/"}
              </span>
            </Col>
            <Col span={5}></Col>
            <Col span={5}></Col>
            <Col span={5} className="alignRight" style={{ paddingBottom: 15 }}>
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.PROSECNA_KOLICINA_DUVANA_U_KG")}:
              </span>
            </Col>
            <Col span={5}>
              <span className={style.fontSize}>
                {dataLicence.prosecnaKolicinaDuvanaKg ?? "/"}
              </span>
            </Col>
            <Col span={5}></Col>
            <Col span={5}></Col>
            <Col span={5} className="alignRight">
              <span className={style.fontSize}>
                {t(
                  "AKCIZNE_DOZVOLE.PROSECNA_KOLICINA_POJEDINACNIH_PAKOVANJA_U_KOMADIMA"
                )}
                :
              </span>
            </Col>
            <Col span={5}>
              <span className={style.fontSize}>
                {dataLicence.prosecnaKolicinaPojedinacnihPakovanjaKomadi ?? "/"}
              </span>
            </Col>
          </>
        ) : (
          <>
            <Col span={5} className="alignRight">
              <span className={style.fontSize}>
                {t(
                  "AKCIZNE_DOZVOLE.KOLICINA_USKLADISTENIH_PROIZVODA_NA_ZALIHAMA_U_PROSTORU"
                )}
                :
              </span>
            </Col>
            <Col span={5}>
              <span className={style.fontSize}>
                {dataLicence.kolicinaUskladistenihProizvoda ?? "/"}
              </span>
            </Col>
            <Col span={5}></Col>
            <Col span={5}></Col>
            <Col span={5} className="alignRight">
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.PROSECAN_MESECNI_RASHOD")}:
              </span>
            </Col>
            <Col span={5}>
              <span className={style.fontSize}>
                {dataLicence.prosecanMesecniRashod ?? "/"}
              </span>
            </Col>
          </>
        )}
      </Row>

      <Row className={style.row}>
        <Col span={1}></Col>
        <Col span={9} className={style.subtitle}>
          <span className={style.fontSize}>
            {t(
              "AKCIZNE_DOZVOLE.ADRESA_GDE_SE_OBAVLJA_PROIZVODNJA_AKCIZNOG_PROIZVODA"
            )}
          </span>
        </Col>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {t("AKCIZNE_DOZVOLE.NACIN_OTPREMANJA_AKCIZNIH_PROIZVODA")}:
          </span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>{dataLicence.nacinOtpremanja}</span>
        </Col>
      </Row>
      <Row className={style.row}>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {t("AKCIZNE_DOZVOLE.ULICA_I_BROJ")}:
          </span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>
            {dataLicence.ulicaProizvodnje} - {dataLicence.brojUliceProizvodnje}
          </span>
        </Col>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {t("AKCIZNE_DOZVOLE.PODATAK_O_MERNIM_UREDJAJIMA")}:
          </span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>
            {dataLicence.podatakOMernimUredjajima}
          </span>
        </Col>
      </Row>
      <Row className={style.row}>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {t("AKCIZNE_DOZVOLE.POSTANSKI_BROJ")}:
          </span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>
            {dataLicence.postanskiBrojProizvodnje}
          </span>
        </Col>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {t(
              "AKCIZNE_DOZVOLE.BROJ_RESENJA_NADLEZNOG_ORGANA_U_POGLEDU_TEHNICKE_OPREMLJENOSTI"
            )}
            :
          </span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>{dataLicence.brojResenja}</span>
        </Col>
      </Row>
      <Row className={style.row}>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>{t("AKCIZNE_DOZVOLE.MESTO")}:</span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>{dataLicence.mestoProizvodnje}</span>
        </Col>
        <Col span={5} className="alignRight">
          <span className={style.fontSize}>
            {t(
              "AKCIZNE_DOZVOLE.DATUM_RESENJA_NADLEZNOG_ORGANA_U_POGLEDU_TEHNICKE_OPREMLJENOSTI"
            )}
            :
          </span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>
            {formatDateDDMMYY(dataLicence.datumResenjaNadleznogOrgana)}
          </span>
        </Col>
      </Row>

      {dataLicence?.kategorijaProizvodaId ===
      AkciznaMarkicaKategorijaProzivoda.DERIVATI_NAFTE ? (
        <Row className={style.row}>
          <Col span={5}></Col>
          <Col span={5}></Col>
          <Col span={5} className="alignRight">
            <span className={style.fontSize}>
              {t("AKCIZNE_DOZVOLE.TARIFNA_OZNAKA")}:
            </span>
          </Col>
          <Col span={5}>
            <span className={style.fontSize}>{dataLicence?.tarifnaOznaka}</span>
          </Col>
        </Row>
      ) : (
        <></>
      )}
    </Col>
  );
};
